// components/Desktop/DesktopMenu.jsx
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import React, { memo } from 'react';
import { useLanguage } from '@components/common/locale/useLanguage';
import MenuNavigation from '../MenuNavigation';
import { processProducts, extractDescriptionText, createCategoryId } from '../utils/categoryHelpers';
import { ProductCardMemoizedSimple } from './ProductCardMemoized';
import './DesktopMenu.scss';
import RandomizedProductPicks from '../RandomizedProductPicks';
var DesktopMenu = /*#__PURE__*/memo(_ref => {
  var {
    categories,
    collections,
    storeStatus,
    selectedCategory,
    handleCategorySelect,
    scrollableContentRef,
    setCategoryRef
  } = _ref;
  var {
    isAr
  } = useLanguage();
  return /*#__PURE__*/React.createElement("div", {
    className: "grid md:grid-cols-1 grid-cols-2 md:grid-rows-[auto_1fr] gap-6 md:gap-[3.8rem] md:gap-y-[0.8rem] min-h-screen overflow-hidden menu-width h-screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-auto overflow-y-auto hide-scrollbar"
  }, /*#__PURE__*/React.createElement(MenuNavigation, {
    onCategorySelect: handleCategorySelect,
    categories: categories,
    activeCategory: selectedCategory
  })), /*#__PURE__*/React.createElement("div", {
    ref: scrollableContentRef,
    className: "col-span-2 pt-4 overflow-y-auto scroll-black no-scrollbar-gutter -mr-4 overflow-x-hidden",
    style: {
      paddingRight: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-32"
  }, /*#__PURE__*/React.createElement(RandomizedProductPicks, {
    storeStatus: storeStatus,
    collections: collections
  })), categories.map(category => {
    var filteredProducts = processProducts(category);
    if (filteredProducts.length === 0) return null;
    var categoryId = createCategoryId(category.name);
    return /*#__PURE__*/React.createElement("div", {
      key: category.name,
      className: "mb-12",
      id: categoryId,
      ref: _ref2 => setCategoryRef(category.name, _ref2)
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-4 mb-8 max-w-[109rem] mx-auto relative ltr:mr-auto rtl:ml-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-[0.8rem] bg-primary w-20 flex-shrink-0"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "text-[#0E0F0B] font-extrabold uppercase text-[1.8rem] whitespace-nowrap"
    }, isAr ? category.nameAr || category.name : category.name), /*#__PURE__*/React.createElement("div", {
      className: "h-[0.8rem] flex-grow relative overflow-visible"
    }, /*#__PURE__*/React.createElement("div", {
      className: "absolute top-0 ltr:left-0 rtl:right-0 h-full bg-primary w-[100vw]"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "grid max-w-[119rem] mx-auto items-end justify-end md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-y-[6rem] mt-[8rem] "
    }, filteredProducts.map(product => {
      var _product$price, _product$image, _product$customizatio;
      var priceText = ((_product$price = product.price) === null || _product$price === void 0 || (_product$price = _product$price.regular) === null || _product$price === void 0 ? void 0 : _product$price.value) || '';
      var imageUrl = (product === null || product === void 0 || (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.single) || '';
      var descriptionText = extractDescriptionText(isAr ? product.descriptionAr || product.description : product.description);
      var isCustomizable = !!((_product$customizatio = product.customizationGroups) !== null && _product$customizatio !== void 0 && _product$customizatio.length);
      return /*#__PURE__*/React.createElement(ProductCardMemoizedSimple, {
        storeStatus: storeStatus,
        key: product.productId,
        image: imageUrl,
        category: isAr ? category.nameAr || category.name : category.name,
        name: isAr ? product.nameAr || product.name : product.name,
        isNewItem: product === null || product === void 0 ? void 0 : product.new_item,
        description: descriptionText,
        price: priceText,
        isSpicy: product.isSpicy,
        url: product.url,
        productId: product.productId,
        isCustomizable: isCustomizable
      });
    })));
  })));
});
DesktopMenu.displayName = 'DesktopMenu';
export default DesktopMenu;